import { render, staticRenderFns } from "./CollegePurchaseDepartment.vue?vue&type=template&id=fc4c33b0"
import script from "./CollegePurchaseDepartment.vue?vue&type=script&lang=js"
export * from "./CollegePurchaseDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports